import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DistributionManifestService = {
  async createBlank() {
    const payload = {
      RecordId: null,
      PlannedDispatchDate: new Date().toSaveDate(),
      RunReference: null,
      CarrierSupplierCode: null,
      Lines: [],
    };

    return await ApiService.post("api/Save_DistributionManifest", payload);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/DistributionManifest",
      top: "1",
      filter: `RecordId eq ${recordId}`,
      expand: "DistributionManifestLines",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(distributionManifest) {
    return await ApiService.post(
      "api/Save_DistributionManifest",
      distributionManifest,
    );
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getAttachedFiles(recordId) {
    const requestScreenData = {
      url: "api/TransactionMediaMeta",
      filter: `TransactionRecordID eq ${recordId} and TransactionType eq 'DistributionManifest'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async updateTransactionMediaMeta(payload) {
    const url = "api/TransactionMediaMeta";
    return await ApiService.post(url, payload);
  },
};

export { DistributionManifestService };
